// removed by extract-text-webpack-plugin
module.exports = {"base":"_1KjSC-34RmCgb9vbiUQdCk","red":"_2r8lFQxHrcaCqcBBJ27f7-","green":"_1z_zTrDJpWIUbXfoyMUROI","bolderText":"HWltBL2QgaPt4m6QqOc1w","buying":"_1cHgxVWkGSNeEDZrEJRh-x","detailsAmountCol":"_1ASaOeamSnxAGbwQZ8yKws","detailsTradingCol":"_2-08K9JrRD2_V21P5ka2VW","detailsTradingFirstCol":"_2DfJzLUq_xP9InSMhky3Gk","detailsTradingSecCol":"_2A2zB1SPG3f6jAMpcEUsgN","tradingStatus":"_1pEYLpPkL7e6mFliFglhdY"};


//////////////////
// WEBPACK FOOTER
// ./src/components/OasisOfferSummary.scss
// module id = 1245
// module chunks = 0